import type { JSX } from 'react'

export const TvPinLockIcon = (): JSX.Element => (
  <use href='#tvPinLockIcon' height='100%' width='100%' />
)
